import {createContext, useContext} from 'react';

interface AppLoadingState {
  isAppLoading: boolean;
  setAppLoading: (appLoading: boolean) => void;
}

/* v8 ignore next -- @preserve */
export const AppLoadingContext = createContext<AppLoadingState>({
  isAppLoading: true,
  setAppLoading: (_isLoading: boolean) => {
    // Defaults to no-op; will be initialized in AppLoadingProvider
  },
});

export function useAppLoading(): AppLoadingState {
  return useContext(AppLoadingContext);
}
